import type { UseVideocastPageHeadResult } from '@/domains/articles/types/VideocastPage.types'
import type { HeadLink, HeadMeta, I18nParams } from '@/types/shared-types'

export default function useVideocastPageHead(
  videocast: Record<string, any> | null | undefined): UseVideocastPageHeadResult {

  const { t } = useI18n()
  const baseUrl = 'https://www.benefitsystems.pl'

  const getPageTitle = () => {
    return videocast?.title || t('pageTitles.articles.title') || ''
  }

  const getPageLink = () => {
    const link: HeadLink[] = []

    link.push({
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    })

    link.push({
      rel: 'canonical',
      href: `${baseUrl}${videocast?.url}`,
    })

    Object.entries(videocast?.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      link.push({
        rel: 'alternate',
        hreflang: langKey,
        href: `${baseUrl}${videocast?.urlsByIsoCode[key]}`,
      })
    })

    link.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}${videocast?.url}`,
    })

    return link
  }

  const getPageMeta = () => {
    const meta: HeadMeta[] = []

    meta.push({
      name: 'description',
      content: videocast?.description || '',
    })

    return meta
  }

  const get18nParams = () => {
    const I18nParams: I18nParams = {}

    Object.entries(videocast?.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      const urlSegment = value.split('/').filter(Boolean).pop()
      I18nParams[langKey] = { url: urlSegment }
    })

    return I18nParams
  }

  return {
    title: getPageTitle(),
    link: getPageLink(),
    meta: getPageMeta(),
    I18nParams: get18nParams(),
  }
}
